import React from "react";
import TextField from "@mui/material/TextField";
import { authTextFieldSx } from "./authStyles";

/**
 * Reusable auth text field — Formik-friendly.
 * Pass name, value, onChange, onBlur, error, helperText from Formik.
 */
function AuthTextField(props) {
  var label = props.label;
  var name = props.name;
  var value = props.value;
  var onChange = props.onChange;
  var onBlur = props.onBlur;
  var error = props.error;
  var helperText = props.helperText;
  var placeholder = props.placeholder;
  var type = props.type || "text";
  var disabled = props.disabled;
  var autoFocus = props.autoFocus;
  var autoComplete = props.autoComplete;
  var inputProps = props.inputProps;
  var id = props.id || name;

  return (
    <TextField
      id={id}
      name={name}
      label={label}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      error={Boolean(error)}
      helperText={helperText || undefined}
      placeholder={placeholder}
      type={type}
      disabled={disabled}
      autoFocus={autoFocus}
      autoComplete={autoComplete}
      fullWidth
      variant="outlined"
      InputLabelProps={{ shrink: true }}
      InputProps={{ notched: false }}
      inputProps={inputProps}
      sx={authTextFieldSx}
    />
  );
}

export default AuthTextField;
